// extracted by mini-css-extract-plugin
export default {"container":"MultiSwitch_container__U6p8T","selected":"MultiSwitch_selected__H5eBZ","notSelected":"MultiSwitch_notSelected__r4tVI"};